import { ref } from "vue";
import {
    DEFAULT_INDESIGN_COLOR_SPACE,
    EXPORT_CONFIGS,
    type ExportFormatType,
    type ExportOptionConfig,
    type InDesignColorSpace
} from "shared-utils/enums/exports";

const colorSpace = ref<InDesignColorSpace>(DEFAULT_INDESIGN_COLOR_SPACE);

export function useDownloadInDesign() {
    function hasColorSpaceSetting(exportFormat: ExportFormatType): boolean {
        const exportConfig: ExportOptionConfig | undefined = EXPORT_CONFIGS[exportFormat];

        return exportConfig?.settings?.includes("colorSpace") ?? false;
    }

    function resetDownloadOptions() {
        colorSpace.value = DEFAULT_INDESIGN_COLOR_SPACE;
    }

    /**
     * Only the InDesign PDF and JPG renditions expose a colour space; every other format gets no
     * InDesign params so PNG/INDD payloads are exactly what they were before the option existed.
     */
    function computeQueryParams(exportFormat: ExportFormatType) {
        if (!hasColorSpaceSetting(exportFormat)) {
            return {};
        }

        return {
            colorSpace: colorSpace.value
        };
    }

    return {
        colorSpace,

        // methods
        hasColorSpaceSetting,
        resetDownloadOptions,
        computeQueryParams
    };
}
